import axios from 'axios';
// Set base URL globally
//axios.defaults.baseURL = "https://concept-clarifier-301795312179.europe-west4.run.app";

// Add a request interceptor to inject the Bearer token
// axios.interceptors.request.use((config) => {
//   const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// }, (error) => {
//   return Promise.reject(error);
// });

const BASEURL = process.env.REACT_APP_CONCEPT_BASEURL;

export const getProjects = async (userIdx) => {
  const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
  const res = await axios.post(`${BASEURL}/get_ideas`, { user_idx: userIdx },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    
  return {idea_list: res.data.idea_list, credit: res.data.credit};
};

export const getStage = async (ideaIdx) => {
  const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie

  const res = await axios.post(`${BASEURL}/get_idea_stage`, { idea_idx: ideaIdx }, 
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return res.data;
};

export const getChatHistory = async (ideaIdx) => {
  const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie

  const res = await axios.post(`${BASEURL}/get_conversation_history`, {
    idea_idx: ideaIdx
  },
  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
  });

  const data = res.data;

  // First message is always from user
  const messages = [
    { sender: 'user', text: data.idea } // First message
  ];
  
  // Alternate between bot/user starting with bot
  data.history.forEach((text, index) => {
    const sender = index % 2 === 0 ? 'bot' : 'user';
    messages.push({ sender, text });
  });

  return {
    title: data.title,     
    messages
  };
};

export const createNewProject = async (userIdx, userText, duration, call = 'TUBITAK') => {
  const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie

  const res = await axios.post(`${BASEURL}/generate_questions`, {
    user_idx: userIdx,
    user_text: userText,
    duration: duration,
    call: call
  }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  
  return {
    idx: res.data.idea_idx,
    title: res.data.title,
    text: res.data.text
  };
};

export const clarifyMessage = async (ideaIdx, text) => {
  const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie

  const res = await axios.post(`${BASEURL}/clarify`, {
    idea_idx: ideaIdx,
    user_text: text
  }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

  return res.data.text;
};

export const getFullProposal = async (ideaIdx) => {
  const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie
  
  const res = await axios.post(`${BASEURL}/get_full_proposal`, {
    idea_idx: ideaIdx
  }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

  return {
    proposal: res.data.proposal,
    wp: res.data.wp_list,
    publications: res.data.publications,
    priority_text: res.data.priority_text,
    project_duration: res.data.project_duration
  };
};


export const deleteIdea = async (ideaIdx) => {
  const token = localStorage.getItem('authToken'); // Or sessionStorage, or from a cookie

  const res = await axios.post(`${BASEURL}/delete_idea`, {
    idea_idx: ideaIdx
  }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  return res.data.text;
};